<template>
  <Dialog
    v-model:visible="visible"
    :modal="true"
    :header="$t('support.modal.title')"
    :style="{ width: '450px' }"
    :closable="true"
    @hide="close"
  >
    <div class="support-modal-content">
      <p class="support-description">{{ $t('support.modal.description') }}</p>

      <div class="contact-section">
        <h4 class="contact-section-title">
          <i class="pi pi-whatsapp"></i>
          {{ $t('support.modal.whatsappSection') }}
        </h4>
        <div class="contact-option" @click="openWhatsApp">
          <div class="contact-info">
            <i class="pi pi-phone"></i>
            <span>{{ $t('support.modal.phoneNumber') }}</span>
          </div>
          <Button
            :label="$t('support.modal.openChat')"
            icon="pi pi-external-link"
            size="small"
            text
            class="contact-button"
          />
        </div>
      </div>

      <div class="contact-section">
        <h4 class="contact-section-title">
          <i class="pi pi-envelope"></i>
          {{ $t('support.modal.emailSection') }}
        </h4>
        <div class="contact-option" @click="openEmail">
          <div class="contact-info">
            <i class="pi pi-at"></i>
            <span>{{ $t('support.modal.email') }}</span>
          </div>
          <Button
            :label="$t('support.modal.sendEmail')"
            icon="pi pi-external-link"
            size="small"
            text
            class="contact-button"
          />
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import { computed } from 'vue'

const props = defineProps<{
  visible: boolean
}>()

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void
}>()

const visible = computed({
  get: () => props.visible,
  set: (value: boolean) => emit('update:visible', value)
})

function close() {
  visible.value = false
}

function openWhatsApp() {
  window.open('https://wa.me/644154001', '_blank')
  close()
}

function openEmail() {
  window.open('mailto:info@kargotr.com', '_blank')
  close()
}
</script>

<style scoped>
.support-modal-content {
  text-align: left;
  padding: 1rem 0;
}

.support-description {
  margin-bottom: 1.5rem;
  color: var(--p-text-color);
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
}

.contact-section {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: var(--p-content-background);
  border-radius: 8px;
  border: 1px solid var(--p-content-border-color);
}

.contact-section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--p-text-color);
}

.contact-section-title i {
  font-size: 1.1rem;
}

.contact-section-title .pi-whatsapp {
  color: #25d366;
}

.contact-section-title .pi-envelope {
  color: var(--p-primary-color);
}

.contact-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background-color: var(--p-content-background);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.contact-option:hover {
  background-color: var(--p-content-hover-background);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.contact-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 500;
  color: var(--p-text-color);
}

.contact-info i {
  color: var(--p-text-muted-color);
  font-size: 1rem;
}

.contact-button {
  color: var(--p-primary-color);
  font-size: 0.875rem;
}

.contact-button:hover {
  color: var(--p-primary-contrast-color);
  background-color: var(--p-primary-color);
}
</style>
